import { DataSourceConfig } from '@core/models';

export class AddDataSourceConfigAction {
  static readonly type = '[DataSourceConfigs] Add Data Source Config';
  constructor(public payload: { dataSourceConfig: DataSourceConfig }) {}
}

export class UpdateDataSourceConfigAction {
  static readonly type = '[DataSourceConfigs] Update Data Source Config';
  constructor(public payload: { dataSourceConfig: DataSourceConfig }) {}
}
